export enum QuestionEditKind {
    None = 0,
    Passage = 1,
    Inquiry = 2,
    Input = 3,
    Analysis = 4,
    Tag = 5,
    Difficulty = 6,
    Visibility = 8,
    CategoryAndKind = 9,
    GroupID = 10,
    NewGroupID = 11,
    ConnectWordIDs = 12,
    StandardAnswer = 13,
    Synonyms = 14,
    Antonyms = 15,
    Mark = 18,
}
